(function() {
  const state = {
    photo: null,
    previewUrl: null,
    petName: "",
    artworkType: "original",
    aiPreviewUrl: null,
    customizationId: null,
    generationStatus: "idle",
    isGeneratingAI: false,
    isUpdatingPreview: false,
    loadingInterval: null,
    previewRequestId: 0,
    previewCache: {},
    printifyMockupUrl: null,
    printifyMockups: [],
    mockupsByColor: null,
    lastErrorType: null
  };

  function initPersonalizer() {
    const personalizer = document.getElementById('paw-personalizer');
    if (!personalizer) return;
    if (personalizer.dataset.initialized === 'true') return;
    personalizer.dataset.initialized = 'true';
    const uploadArea = document.getElementById('paw-upload-area');
    const fileInput = document.getElementById('paw-file-input');
    const previewArea = document.getElementById('paw-preview-area');
    const thumbnail = document.getElementById('paw-thumbnail');
    const btnReplace = document.getElementById('paw-btn-replace');
    const btnRemove = document.getElementById('paw-btn-remove');
    const petNameInput = document.getElementById('paw-pet-name');
    const charCounter = document.getElementById('paw-char-counter');
    const validationMessage = document.getElementById('paw-validation-message');
    const addToCartForm = document.querySelector('form[action*="/cart/add"]') || document.querySelector('form.shopify-product-form');

    const cropperModal = document.getElementById('paw-cropper-modal');
    const cropperImage = document.getElementById('paw-cropper-image');
    const cropperCancelBtn = document.getElementById('paw-cropper-cancel');
    const cropperSelectBtn = document.getElementById('paw-cropper-select');
    
    const loadingUI = document.getElementById('paw-ai-loading');
    const loadingBar = document.getElementById('paw-progress-bar');
    const loadingTitle = document.getElementById('paw-stage-title');
    
    const errorBanner = document.getElementById('paw-error-banner');
    const errorTitle = document.getElementById('paw-error-title');
    const errorDesc = document.getElementById('paw-error-desc');
    const errorRetry = document.getElementById('paw-error-retry');
    const errorDismiss = document.getElementById('paw-error-dismiss');

    const BACKEND_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:3001' : 'https://paw-squad-caricature-backend.onrender.com';
    let cropperInstance = null;

    function setMockupIndicator(isLoading) {
        let indicator = document.getElementById('paw-mockup-status');
        if (!indicator && previewArea) {
            indicator = document.createElement('div');
            indicator.id = 'paw-mockup-status';
            indicator.style.cssText = 'font-size: 11px; color: #6e6e73; text-align: center; margin-top: 6px; display: none; transition: opacity 0.2s;';
            previewArea.appendChild(indicator);
        }
        if (indicator) {
            if (isLoading) {
                indicator.textContent = "Updating shirt mockup...";
                indicator.style.display = 'block';
                indicator.style.opacity = '1';
            } else {
                indicator.style.opacity = '0';
                setTimeout(() => { if (!state.isUpdatingPreview) indicator.style.display = 'none'; }, 300);
            }
        }
    }

    function dispatchUpdate(printifyMockupUrl = null, printifyMockups = null, mockupsByColor = null) {
        if (!personalizer) return;
        
        let finalPrintifyMockup = printifyMockupUrl || state.printifyMockupUrl;
        let finalPrintifyMockups = printifyMockups || state.printifyMockups || [];
        let finalMockupsByColor = mockupsByColor || state.mockupsByColor || null;
        const colorInput = document.querySelector('input[data-option-name="Color"]:checked, select[data-option-name="Color"]');
        const selectedColor = colorInput ? colorInput.value : 'Black';

        personalizer.dispatchEvent(new CustomEvent('paw:update-preview', {
            bubbles: true,
            detail: {
                previewUrl: state.previewUrl,
                petName: state.petName,
                artworkType: state.artworkType,
                customizationId: state.customizationId,
                printifyMockupUrl: finalPrintifyMockup,
                printifyMockups: finalPrintifyMockups,
                mockupsByColor: finalMockupsByColor,
                selectedColor: selectedColor
            }
        }));
    }

    let cropperPromise = null;
    function loadCropper() {
        if (cropperPromise) return cropperPromise;
        cropperPromise = new Promise((resolve, reject) => {
            if (window.Cropper) return resolve();
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = 'https://cdnjs.cloudflare.com/ajax/libs/cropperjs/1.5.13/cropper.min.css';
            document.head.appendChild(link);
            const script = document.createElement('script');
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/cropperjs/1.5.13/cropper.min.js';
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
        return cropperPromise;
    }

    function showError(title, msg, errorType = 'ai') {
        state.lastErrorType = errorType;
        if (errorTitle) errorTitle.textContent = title;
        if (errorDesc) errorDesc.textContent = msg;
        if (errorBanner) errorBanner.style.display = 'block';
    }
    
    function hideError() {
        if (errorBanner) errorBanner.style.display = 'none';
    }
    
    if (errorDismiss) {
        errorDismiss.addEventListener('click', hideError);
    }
    if (errorRetry) {
        errorRetry.addEventListener('click', () => {
            hideError();
            if (state.lastErrorType === 'preview') {
                requestPrintifyPreview();
            } else if (state.photo) {
                startAIGeneration();
            }
        });
    }

    async function startAIGeneration() {
        if (state.isGeneratingAI) return;
        state.isGeneratingAI = true;
        state.generationStatus = "loading";
        hideError();
        
        if (loadingUI) loadingUI.style.display = 'flex';
        
        const stages = [
            { title: "Analyzing...", duration: 5000 },
            { title: "Mapping features...", duration: 8000 },
            { title: "Creating artwork...", duration: 15000 },
            { title: "Refining details...", duration: 8000 },
            { title: "Finalizing...", duration: 5000 }
        ];
        
        let totalTime = stages.reduce((acc, s) => acc + s.duration, 0);
        let passedTime = 0;
        let stageIndex = -1;
        
        if (loadingBar) loadingBar.style.width = '0%';
        
        state.loadingInterval = setInterval(() => {
            passedTime += 100;
            let percent = Math.min((passedTime / totalTime) * 100, 99);
            if (loadingBar) loadingBar.style.width = percent + '%';
            
            let currentStageTime = 0;
            for (let i = 0; i < stages.length; i++) {
                currentStageTime += stages[i].duration;
                if (passedTime < currentStageTime || i === stages.length - 1) {
                    if (stageIndex !== i) {
                        stageIndex = i;
                        if (loadingTitle) loadingTitle.textContent = stages[i].title;
                    }
                    break;
                }
            }
        }, 100);

        try {
            if (!state.customizationId) {
                 const formData = new FormData();
                 formData.append('photo', state.photo, 'cropped.png');
                 formData.append('pet_name', state.petName || 'Pet');
                 const initRes = await fetch(`${BACKEND_URL}/api/customization/init`, { method: 'POST', body: formData });
                 const initData = await initRes.json();
                 if (!initData.success) throw new Error(initData.error || "Failed to upload image.");
                 state.customizationId = initData.customization_id;
            }

            const genRes = await fetch(`${BACKEND_URL}/api/customization/generate`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ customization_id: state.customizationId })
            });
            const genData = await genRes.json();
            
            if (genData.success) {
                // AI generation complete! Unblock UI immediately
                clearInterval(state.loadingInterval);
                state.isGeneratingAI = false;
                if (loadingUI) loadingUI.style.display = 'none';

                state.generationId = genData.generation_id || null;
                state.aiPreviewUrl = genData.generated_url;
                state.previewUrl = genData.generated_url;
                state.generationStatus = "success";
                
                // Invalidate any previously cached mockups for AI artwork now that new artwork exists
                Object.keys(state.previewCache).forEach(k => {
                    if (k.includes('_ai_')) delete state.previewCache[k];
                });

                if (thumbnail) {
                    thumbnail.src = state.previewUrl;
                }
                
                // Automatically switch to AI artwork
                state.artworkType = "ai";
                const aiRadio = personalizer.querySelector('input[name="artworkType"][value="ai"]');
                if (aiRadio) {
                    aiRadio.checked = true;
                    aiRadio.disabled = false;
                    aiRadio.closest('.paw-radio-card').classList.remove('disabled');
                    aiRadio.closest('.paw-radio-card').classList.add('selected');
                    const origRadio = personalizer.querySelector('input[name="artworkType"][value="original"]');
                    if (origRadio) origRadio.closest('.paw-radio-card').classList.remove('selected');
                }
                
                // Immediately reveal the caricature in the personalization interface
                dispatchUpdate();
                
                // Kick off Printify Preview as an asynchronous, non-blocking stage
                requestPrintifyPreview();
                
            } else {
                throw new Error(genData.error || "AI generation returned an error.");
            }
        } catch(e) { 
            const isTimeout = e.message.toLowerCase().includes('timeout') || e.message.toLowerCase().includes('fetch');
            const errTitle = isTimeout ? 'Connection Error' : 'AI Generation Failed';
            showError(errTitle, e.message || "An unexpected error occurred during generation.", 'ai');
            state.generationStatus = "error";
        } finally {
            clearInterval(state.loadingInterval);
            state.isGeneratingAI = false;
            if (loadingUI) loadingUI.style.display = 'none';
        }
    }

    function handleFile(file) {
        if (!file) return;
        state.photo = file;
        
        const reader = new FileReader();
        reader.onload = (ev) => {
          const img = new Image();
          img.onload = () => {
              let width = img.naturalWidth;
              let height = img.naturalHeight;
              const MAX_SIZE = 1024;
              
              if (width > MAX_SIZE || height > MAX_SIZE) {
                  if (width > height) {
                      height = Math.round(height * (MAX_SIZE / width));
                      width = MAX_SIZE;
                  } else {
                      width = Math.round(width * (MAX_SIZE / height));
                      height = MAX_SIZE;
                  }
              }
              
              const canvas = document.createElement('canvas');
              canvas.width = width;
              canvas.height = height;
              const ctx = canvas.getContext('2d');
              ctx.drawImage(img, 0, 0, width, height);
              
              cropperImage.src = canvas.toDataURL('image/jpeg', 0.95);
              
              loadCropper().then(() => {
                  cropperModal.style.display = 'flex';
                  if (cropperInstance) cropperInstance.destroy();
                  cropperInstance = new Cropper(cropperImage, {
                    aspectRatio: 1,
                    viewMode: 1,
                    autoCropArea: 0.8,
                  });
              });
          };
          img.src = ev.target.result;
        };
        reader.readAsDataURL(file);
    }
    
    function closeCropper() {
        cropperModal.style.display = 'none';
        if (cropperInstance) cropperInstance.destroy();
        if (fileInput) fileInput.value = '';
    }

    if (cropperCancelBtn) {
        cropperCancelBtn.addEventListener('click', closeCropper);
    }

    if (!window.pawCropperEscBound) {
        window.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && cropperModal && cropperModal.style.display === 'flex') {
                closeCropper();
            }
        });
        window.pawCropperEscBound = true;
    }

    async function requestPrintifyPreview() {
        if (!state.customizationId || !state.petName || (!state.aiPreviewUrl && !state.photo)) return;

        // Get selected options
        let size = null;
        let color = null;
        
        const colorInput = document.querySelector('input[data-option-name="Color"]:checked, select[data-option-name="Color"]');
        if (colorInput) color = colorInput.value;
        
        const sizeInput = document.querySelector('input[data-option-name="Size"]:checked, select[data-option-name="Size"]');
        if (sizeInput) size = sizeInput.value;

        if (!size || !color) {
            console.log("[PawSquad] Size or color not selected yet. Cannot generate Printify preview.");
            return;
        }

        const requestId = ++state.previewRequestId;
        const artworkIdentity = state.artworkType === 'ai' ? (state.generationId || 'ai-latest') : 'orig';
        const cacheKey = `${state.customizationId}_${state.artworkType}_${artworkIdentity}_${color}_${size}_${state.petName.trim().toLowerCase()}`;

        // Return immediately if cached
        if (state.previewCache[cacheKey]) {
            console.log("[PawSquad] Using cached Printify preview mockup:", cacheKey);
            const cached = state.previewCache[cacheKey];
            if (typeof cached === 'string') {
                state.printifyMockupUrl = cached;
                state.printifyMockups = [{ mockup_id: 'front-2', src: cached }];
                state.mockupsByColor = null;
            } else if (cached && typeof cached === 'object') {
                state.printifyMockupUrl = cached.preview_url || null;
                state.printifyMockups = Array.isArray(cached.mockups) ? cached.mockups : [];
                state.mockupsByColor = cached.mockups_by_color || null;
            }
            dispatchUpdate();
            return;
        }

        state.isUpdatingPreview = true;
        setMockupIndicator(true);

        try {
            const res = await fetch(`${BACKEND_URL}/api/customization/printify-preview`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    customization_id: state.customizationId,
                    pet_name: state.petName,
                    shopify_size: size,
                    shopify_color: color,
                    artwork_type: state.artworkType
                })
            });
            
            const data = await res.json();
            
            // Prevent stale responses
            if (state.previewRequestId !== requestId) {
                console.log("[PawSquad] Ignored stale Printify preview response.");
                return;
            }

            if (data.success && data.preview_url) {
                const mockupsList = Array.isArray(data.mockups) && data.mockups.length > 0
                    ? data.mockups
                    : [{ mockup_id: 'front-2', src: data.preview_url }];
                const mockupsByColor = data.mockups_by_color && typeof data.mockups_by_color === 'object'
                    ? data.mockups_by_color
                    : null;
                state.previewCache[cacheKey] = {
                    preview_url: data.preview_url,
                    mockups: mockupsList,
                    mockups_by_color: mockupsByColor
                };
                state.printifyMockupUrl = data.preview_url;
                state.printifyMockups = mockupsList;
                state.mockupsByColor = mockupsByColor;
                dispatchUpdate();
            } else {
                throw new Error(data.error || "Failed to generate Printify preview.");
            }
        } catch(e) {
            if (state.previewRequestId === requestId) {
                console.warn("[PawSquad] Printify preview warning:", e.message);
                showError("Shirt Preview Notice", "Printify preview took longer than expected. Your custom artwork is saved! Click Retry to reload the shirt preview.", 'preview');
            }
        } finally {
            if (state.previewRequestId === requestId) {
                state.isUpdatingPreview = false;
                setMockupIndicator(false);
            }
        }
    }

    // Listen to variant changes
    if (!window.pawVariantListenersBound) {
        document.body.addEventListener('change', (e) => {
            if (e.target.matches('input[data-option-name], select[data-option-name]')) {
                if (state.customizationId && state.petName && (state.aiPreviewUrl || state.photo)) {
                    requestPrintifyPreview();
                }
            }
        });
        window.pawVariantListenersBound = true;
    }

    if (cropperSelectBtn) {
        cropperSelectBtn.addEventListener('click', () => {
            if (!cropperInstance) return;
            const croppedCanvas = cropperInstance.getCroppedCanvas({ width: 1024, height: 1024 });
            
            croppedCanvas.toBlob(async (blob) => {
                state.photo = blob;
                state.previewCache = {};
                
                if (state.previewUrl) URL.revokeObjectURL(state.previewUrl);
                state.previewUrl = URL.createObjectURL(blob);
                
                thumbnail.src = state.previewUrl;
                uploadArea.style.display = 'none';
                previewArea.style.display = 'flex';
                validationMessage.style.display = 'none';
                cropperModal.style.display = 'none';
                
                // Cancel previous if new upload starts
                if (state.isGeneratingAI) {
                    clearInterval(state.loadingInterval);
                    state.isGeneratingAI = false;
                    loadingUI.style.display = 'none';
                }
                state.customizationId = null;
                state.printifyMockupUrl = null;
                
                dispatchUpdate();
                startAIGeneration();
            }, 'image/png');
        });
    }

    // Event Listeners
    if (uploadArea) {
      uploadArea.addEventListener('click', () => fileInput.click());
      
      uploadArea.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              fileInput.click();
          }
      });
      
      uploadArea.addEventListener('dragover', (e) => {
          e.preventDefault();
          uploadArea.style.borderColor = '#0066cc';
      });
      
      uploadArea.addEventListener('dragleave', () => {
          uploadArea.style.borderColor = '#d2d2d7';
      });
      
      uploadArea.addEventListener('drop', (e) => {
          e.preventDefault();
          uploadArea.style.borderColor = '#d2d2d7';
          if (e.dataTransfer.files && e.dataTransfer.files[0]) {
              handleFile(e.dataTransfer.files[0]);
          }
      });
    }

    if (fileInput) {
      fileInput.addEventListener('change', (e) => {
          if (e.target.files && e.target.files[0]) {
              handleFile(e.target.files[0]);
          }
      });
    }

    if (btnReplace) btnReplace.addEventListener('click', () => fileInput.click());

    if (btnRemove) {
      btnRemove.addEventListener('click', () => {
          state.photo = null;
          state.customizationId = null;
          state.aiPreviewUrl = null;
          state.previewCache = {};
          state.printifyMockupUrl = null;
          state.printifyMockups = [];
          state.mockupsByColor = null;
          hideError();
          if (state.isGeneratingAI) {
              clearInterval(state.loadingInterval);
              state.isGeneratingAI = false;
              if (loadingUI) loadingUI.style.display = 'none';
          }
          if (state.previewUrl) URL.revokeObjectURL(state.previewUrl);
          state.previewUrl = null;
          fileInput.value = '';
          
          uploadArea.style.display = 'block';
          previewArea.style.display = 'none';
          dispatchUpdate();
      });
    }

    if (petNameInput) {
      petNameInput.addEventListener('input', (e) => {
          state.petName = e.target.value;
          charCounter.textContent = `${state.petName.length}/20`;
          if (state.petName.length > 0) validationMessage.style.display = 'none';
          dispatchUpdate();
      });
    }

    const artworkRadios = personalizer.querySelectorAll('input[name="artworkType"]');
    artworkRadios.forEach(radio => {
        radio.addEventListener('change', (e) => {
            if (e.target.disabled) return;
            state.artworkType = e.target.value;
            
            artworkRadios.forEach(r => {
                if (r.checked) r.closest('.paw-radio-card').classList.add('selected');
                else r.closest('.paw-radio-card').classList.remove('selected');
            });
            
            if (state.artworkType === 'ai' && state.aiPreviewUrl) {
                state.previewUrl = state.aiPreviewUrl;
            } else if (state.photo) {
                state.previewUrl = URL.createObjectURL(state.photo);
            }
            
            if (thumbnail && state.previewUrl) {
                thumbnail.src = state.previewUrl;
            }
            
            state.printifyMockupUrl = null;
            state.printifyMockups = [];
            state.mockupsByColor = null;
            dispatchUpdate();
            if (state.customizationId) {
                requestPrintifyPreview();
            }
        });
    });

    if (addToCartForm && addToCartForm.dataset.pawInitialized !== 'true') {
        addToCartForm.dataset.pawInitialized = 'true';
        addToCartForm.addEventListener('submit', (e) => {
            if (state.isGeneratingAI) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                validationMessage.textContent = "Please wait for AI generation to finish.";
                validationMessage.style.display = 'block';
                return false;
            }
            if (!state.photo || !state.customizationId || !state.previewUrl) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                validationMessage.textContent = "Please upload your pet's photo and wait for processing.";
                validationMessage.style.display = 'block';
                return false;
            }
            if (!state.petName.trim()) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                validationMessage.textContent = "Please enter your pet's name.";
                validationMessage.style.display = 'block';
                return false;
            }
            if (!state.artworkType) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                validationMessage.textContent = "Please select an artwork type.";
                validationMessage.style.display = 'block';
                return false;
            }
            
            // Inject Line Item Properties
            const finalPreviewUrl = state.artworkType === 'ai' && state.aiPreviewUrl ? state.aiPreviewUrl : state.previewUrl;
            
            const properties = {
                '_customization_id': state.customizationId,
                '_preview_url': finalPreviewUrl,
                '_artwork_type': state.artworkType,
                '_pet_name': state.petName,
                '_generation_status': state.generationStatus,
                'Pet Name': state.petName,
                'Artwork Type': state.artworkType === 'ai' ? 'Paw Squad AI' : 'Original Photo',
                'Custom Design': 'Included'
            };
            
            for (const [key, value] of Object.entries(properties)) {
                let input = addToCartForm.querySelector(`input[name="properties[${key}]"]`);
                if (!input) {
                    input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = `properties[${key}]`;
                    addToCartForm.appendChild(input);
                }
                input.value = value;
            }
            
            // Clean up temporary UI state without reload (allow natural ajax cart response)
            setTimeout(() => {
                state.photo = null;
                state.customizationId = null;
                state.aiPreviewUrl = null;
                state.generationStatus = "idle";
                if (state.previewUrl) URL.revokeObjectURL(state.previewUrl);
                state.previewUrl = null;
                state.petName = "";
                
                if (fileInput) fileInput.value = '';
                if (petNameInput) petNameInput.value = '';
                if (charCounter) charCounter.textContent = '0/20';
                
                uploadArea.style.display = 'block';
                previewArea.style.display = 'none';
                
                const aiRadio = personalizer.querySelector('input[name="artworkType"][value="ai"]');
                if (aiRadio) {
                    aiRadio.checked = false;
                    aiRadio.closest('.paw-radio-card').classList.remove('selected');
                }
                const originalRadio = personalizer.querySelector('input[name="artworkType"][value="original"]');
                if (originalRadio) {
                    originalRadio.checked = true;
                    originalRadio.closest('.paw-radio-card').classList.add('selected');
                }
                state.artworkType = "original";
                state.printifyMockupUrl = null;
                state.printifyMockups = [];
                state.mockupsByColor = null;
                
                dispatchUpdate();
            }, 1000);
            
        }, true);
    }
  }

  document.addEventListener('DOMContentLoaded', initPersonalizer);
  document.addEventListener('shopify:section:load', initPersonalizer);
})();
